<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <QuizForm :activity="activity" :questions="questions" :options="options" :meta="meta" />
    </PanelPage>
</template>

<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizForm from '@/Pages/Teacher/Quiz/Activity/Preview/QuizForm.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import CountdownTimer from '@/components/CountdownTimer.vue';

export default {
    components: {
        CountdownTimer,
        AlertMessage,
        QuizForm,
        PanelPage,
    },
    layout: LandingLayout,
    name: 'Create',
    props: ['meta', 'options', 'questions', 'activity'],
};
</script>
